import React, { useEffect, useMemo, useState } from 'react';
import { BackButton2 } from '../../../../../common/BackButton2';
import RichTextBox from './RichTextBox';
import { useLocation, useNavigate } from 'react-router-dom';
import faqAddORUpdate from './FaqAddOrUpdate';
import { FaPlus } from 'react-icons/fa';
import AccountSetupButton from '../../../../../common/AccountSetupButton';
import CostomTooltip from '../../../../../common/CostomTooltip';
import { HOSPITALITY_LIST, RETAILER_LIST } from '../../DATA';

interface IProps {
  questionsList: { question: string; answer: string; uuid?: string | null }[];
  faqList: { uuid: string | null; faq: { question: string; answer: string }[] }[];
  setQuestionsList: any;
  disable: any;
  setDisable: any;
  fetchAllFaq: any;
  setFaqList: any;
  isLoading: boolean;
  handleDeleteFaq: (index: number, faqUUID: string) => void;
  isSettings: any;
  allquestionsList: { question: string; answer: string; uuid?: string | null }[];
  fetchAllDocuments: () => void;
}
const FaqManual = (props: IProps) => {
  const {
    questionsList,
    faqList,
    setQuestionsList,
    disable,
    setDisable,
    fetchAllFaq,
    setFaqList,
    isLoading,
    handleDeleteFaq,
    isSettings,
    allquestionsList,
    fetchAllDocuments
  } = props;

  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const optimizedQuestionsList = useMemo(() => questionsList, [questionsList]);

  const [isAddOrEditPopUpOpen, setIsAddOrEditPopUpOpen] = useState(false);
  const [subscriptionData, setSubscriptionData] = useState<any>(null);

  useEffect(() => {
    setTimeout(() => {
      const subscriptionPlanDetail = sessionStorage.getItem('planDetail');
      if (subscriptionPlanDetail) {
        setSubscriptionData(JSON.parse(subscriptionPlanDetail));
      }
    }, 100);
  }, []);

  const faqPost = () => {
    faqAddORUpdate({
      questionsList,
      setQuestionsList,
      faqList,
      allquestionsList,
      navigate,
      setDisable,
      isSettings,
      fetchAllFaq,
      pathname,
      fetchAllDocuments,
      setFaqList
    });
  };

  useEffect(() => {
    if (faqList.length === 0) {
      fetchAllFaq();
    }
  }, []);

  const isTooltipDisabled = () => {
    const { analytics, faqLimit } = subscriptionData?.data || {};
    if (['Pro', 'Advanced'].includes(analytics)) {
      return false;
    }
    if (analytics === 'Free' && optimizedQuestionsList.length >= faqLimit) {
      return true;
    }
    return false; // Default case
  };

  return (
    <div className="w-full mt-6">
      <div className={`flex justify-between mr-7 ml-9 items-center`}>
        <label className="text-sm font-medium">Generated FAQ</label>
        <CostomTooltip
          text={`Your current plan doesn't support adding more Faq. Please upgrade to continue.`}
          position="left"
          isDisabled={isTooltipDisabled()}
        >
          <div
            className="bg-[#006BEA] rounded flex justify-center items-center cursor-pointer p-2"
            onClick={() => (isTooltipDisabled() ? null : setIsAddOrEditPopUpOpen(true))}
          >
            <FaPlus />
          </div>
        </CostomTooltip>
      </div>

      <div className="h-[300px] overflow-y-auto border-4 rounded-lg ml-9 m-7 mb-0 border-[#343434]">
        {isLoading ? (
          <div className="flex items-center justify-center h-[70%] w-full text-white text-lg font-bold">
            <>
              <div className="fixed inset-0 bg-black bg-opacity-50 z-40"></div>

              <div className="fixed inset-0 flex items-center justify-center z-50">
                <div className="loader border-t-4 border-[#006BEA] rounded-full w-12 h-12 animate-spin"></div>
              </div>
            </>
          </div>
        ) : (
          <RichTextBox
            questionsList={optimizedQuestionsList}
            setQuestionsList={setQuestionsList}
            handleDeleteFaq={handleDeleteFaq}
            setIsAddOrEditPopUpOpen={setIsAddOrEditPopUpOpen}
            isAddOrEditPopUpOpen={isAddOrEditPopUpOpen}
            setFaqList={setFaqList}
            faqList={faqList}
            allquestionsList={allquestionsList}
            fetchAllDocuments={fetchAllDocuments}
          />
        )}
      </div>

      <div className="flex justify-end gap-2.5 -mt-3 mr-8">
        {!isSettings && (
          <AccountSetupButton
            isFormValid={true}
            btnText="Skip"
            textColor="#FFFFFF"
            backGroundColor="#1E1E1E"
            borderColor="#006BEA"
            onClick={() => navigate('/account-setup/widgets')}
          />
        )}
        <AccountSetupButton
          isFormValid={true}
          btnText="Proceed"
          textColor="#FFFFFF"
          backGroundColor="#006BEA"
          borderColor="#006BEA"
          onClick={() => faqPost()}
          disable={disable}
        />
      </div>
      {disable && (
        <>
          <div className="fixed inset-0 bg-black bg-opacity-50 z-40"></div>
          <div className="fixed inset-0 flex items-center justify-center z-50">
            <div className="loader border-t-4 border-[#006BEA] rounded-full w-12 h-12 animate-spin"></div>
          </div>
        </>
      )}
    </div>
  );
};
export default FaqManual;
